<template>
  <div>
    <el-card shadow="always">
      <div style="display: flex; justify-content: space-between">
        <div style="display: flex">
          <el-input size="small" style="width: 250px" placeholder="搜索关键字" clearable v-model.trim="params.keyword" @change="getData()">
            <el-button slot="append" icon="el-icon-search" @click="getData"></el-button>
          </el-input>
          <el-button size="small" icon="el-icon-refresh" style="width: 80px; margin: 0 2px" @click="getData">刷新</el-button>
        </div>
        <el-button size="small" type="primary" @click="saveDialog()">添加</el-button>
      </div>
    </el-card>
    <el-table height="600" size="small" :data="tableData.list" border row-key="id" class="box-card mt10">
      <el-table-column prop="id" label="ID" width="60"> </el-table-column>
      <el-table-column prop="username" label="用户名" width="120"> </el-table-column>
      <el-table-column prop="role_name" label="角色" width="120"> </el-table-column>
      <el-table-column prop="employee_name" label="绑定员工" width="120"></el-table-column>
      <el-table-column label="绑定微信" width="100">
        <template slot-scope="scope">
          <el-tag size="mini" type="success" v-if="scope.row.open_id">已绑定</el-tag>
          <el-tag size="mini" type="info" v-else>未绑定</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" width="150">
        <template slot-scope="scope">
          {{ scope.row.create_time | date }}
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="420" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="bindEmployee(scope.row)" v-if="!scope.row.employee_id">绑定员工</el-button>
          <el-button size="mini" type="info" @click="unbindEmployee(scope.row)" v-if="scope.row.employee_id">解绑员工</el-button>
          <el-button size="mini" type="primary" @click="bindWeChat(scope.row)" v-if="!scope.row.open_id">绑定微信</el-button>
          <el-button size="mini" type="info" @click="unbindWeChat(scope.row)" v-if="scope.row.open_id">解绑微信</el-button>
          <el-button size="mini" type="success" @click="saveDialog(scope.row)">编辑</el-button>
          <el-button size="mini" type="warning" @click="deleteData(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total,sizes,prev, pager, next"
      :page-sizes="[15, 30, 50, 100]"
      :total="tableData.total"
      :page-size="tableData.page_size"
      :current-page="tableData.page"
      @current-change="pageChange"
      @size-change="pageSizeChange"
      class="box-card pd10 mt10"
    >
    </el-pagination>
    <el-dialog :title="dialogTitle" :visible.sync="dialogShow" width="480px">
      <user-save ref="userSaveRef" @callMethod="refresh"></user-save>
    </el-dialog>
    <el-dialog title="绑定员工" :visible.sync="bindEmployeeShow" width="300px" :close-on-click-modal="false" :close-on-press-escape="false" destroy-on-close>
      <el-form size="small" label-width="60px" style="padding: 20px">
        <el-form-item label="员工">
          <employee-select v-model="formData.employee_id" style="width: 180px"></employee-select>
        </el-form-item>
      </el-form>
      <div class="form-but">
        <el-button size="small" type="primary" :loading="loading" @click="bindEmployeeSave()">绑定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="绑定微信" :visible.sync="bindWeChatShow" width="256px" :close-on-click-modal="false" :close-on-press-escape="false" destroy-on-close>
      <el-image style="width: 256px; height: 256px" :src="qrcodeBase64" fit="contain"></el-image>
      <span style="display: block; text-align: center; padding-bottom: 20px">用微信扫一扫(10分钟有效)</span>
    </el-dialog>
  </div>
</template>

<script>
import UserSave from '@/components/auth/userSave.vue'
import EmployeeSelect from '@/components/employee/select'
export default {
  name: 'authUserList',
  components: {
    UserSave,
    EmployeeSelect
  },
  created() {
    this.getData()
  },
  data() {
    return {
      dialogTitle: '',
      dialogShow: false,
      bindEmployeeShow: false,
      bindWeChatShow: false,
      loading: false,
      tableData: {
        page: 0,
        page_count: 0,
        page_size: 0,
        total: 0,
        list: []
      },
      params: {
        page: 1,
        page_size: 15,
        keyword: ''
      },
      formData: {
        id: '',
        employee_id: ''
      },
      qrcodeBase64: ''
    }
  },
  methods: {
    // 绑定员工
    bindEmployee(row) {
      this.formData.id = row.id
      this.bindEmployeeShow = true
    },
    // 解绑员工
    unbindEmployee(row) {
      this.$confirm('确定解绑吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          await this.$api.auth.userUnbindEmployee({ id: row.id }).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg)
              this.refresh()
            }
          })
        })
        .catch(() => {
          this.$message.info('已取消')
        })
    },
    // 保存员工绑定
    async bindEmployeeSave() {
      if (!this.formData.employee_id) {
        this.$message.error('请选择员工')
        return
      }
      const params = {
        id: this.formData.id,
        employee_id: this.formData.employee_id
      }
      this.loading = true
      await this.$api.auth.userBindEmployee(params).then(res => {
        this.loading = false
        if (res.code == 200) {
          this.$message.success(res.msg)
          this.refresh()
        }
      })
    },
    // 绑定微信
    async bindWeChat(row) {
      await this.$api.auth.userBindWechatQrcode({ id: row.id }).then(res => {
        if (res.code == 200 && res.data) {
          this.qrcodeBase64 = res.data.dataURL
          this.bindWeChatShow = true
        }
      })
    },
    // 解绑微信
    unbindWeChat(row) {
      this.$confirm('确定解绑吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          await this.$api.auth.userUnbindWechat({ id: row.id }).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg)
              this.refresh()
            }
          })
        })
        .catch(() => {
          this.$message.info('已取消')
        })
    },
    // 获取数据
    async getData() {
      await this.$api.auth.userList().then(res => {
        if (res.code == 200) {
          this.tableData = res.data ? res.data : {}
        }
      })
    },
    // 添加、编辑
    saveDialog(data) {
      this.dialogShow = true
      if (data) {
        this.dialogTitle = '编辑管理员'
        this.$nextTick(() => {
          this.$refs.userSaveRef.setData(data)
        })
      } else {
        this.dialogTitle = '添加管理员'
        this.$nextTick(() => {
          this.$refs.userSaveRef.setData()
        })
      }
    },
    //  删除
    async deleteData(id) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          await this.$api.auth.userDelete({ id: id }).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg)
              this.refresh()
            }
          })
        })
        .catch(() => {
          this.$message.info('已取消删除')
        })
    },
    // 分页切换
    pageChange(page) {
      this.params.page = page
      this.getData()
    },
    // 分页大小切换
    pageSizeChange(pageSize) {
      this.params.page_size = pageSize
      this.getData()
    },
    refresh() {
      this.dialogShow = false
      this.bindEmployeeShow = false
      this.getData()
    }
  }
}
</script>
